module.exports = __webpack_public_path__ + "assets/img/new-api.07fa2712.svg";